<template>
  <div class="layout_header">
    <div class="header_top">
      <div
        class="backHome"
        v-if="
          ['/login/index', '/register/index', '/moreDetail'].includes(
            activeIndex
          )
        "
        @click="$router.push('/')"
      >
        返回首页
      </div>
      <div class="logoBox">
        <div class="logo_top" @click="$router.push({ path: '/' })">
          <div class="logo1">
            <img height="80" src="@/assets/images/home/logo.jpg" alt="" />
          </div>
          <div class="logo3">
            <p>"一带一路"职业教育国际合作服务平台</p>

            <div class="logo_bottom">
              The Belt and Road Vocational Education International Cooperation
              Service Platform
            </div>
          </div>
        </div>
      </div>
      <div
        class="loginRegist"
        v-if="
          !['/login/index', '/register/index', '/moreDetail'].includes(
            activeIndex
          )
        "
      >
        <!-- <div class="language">English</div> -->
        <el-button
          v-if="!userInfo.user_id"
          round
          type="primary"
          plain
          size="mini"
          @click="$router.push('/login')"
          style="padding: 7px 20px;margin-right: 15px;"
          >登录</el-button
        >

        <div class="userInfo" v-if="userInfo.user_id">
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: flex-start;
            "
          >
            <img class="userImg" :src="userInfo.avatar" />
            <p class="userName">
              <span>{{ userInfo.real_name }}</span>
              <span v-if="dataTypeList[userInfo.data_type]">
                {{ dataTypeList[userInfo.data_type] }}
              </span>
            </p>
          </div>

          <el-button
            v-if="userInfo.user_id"
            round
            type="danger"
            plain
            size="mini"
            @click="goOut"
            style="padding: 7px 20px"
            >退出</el-button
          >
        </div>
      </div>
    </div>
    <div
      class="header_bg"
      v-if="!['/register/index', '/login/index'].includes(activeIndex)"
    >
      <img src="@/assets/images/home/bg1.png" alt="" />
    </div>
  </div>
</template>

<script>
import routerList from "@/router/views/index";
import { mapGetters } from "vuex";
export default {
  name: "layout-header",
  data() {
    return {
      dataTypeList: { 1: "院校", 2: "机构" },
      isact: "",
      activeIndex: "/index",
      menuBack: "#015293",
      activeTextColor: "#ffffff",
      navList: [],
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler: function (val, oldVal) {
        console.log(val, 666);
        this.activeIndex = val.path;
        this.isact = val.path;
      },
      // 深度观察监听
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    this.navList = routerList;
  },
  methods: {
    toUserCenter() {
      this.$router.push({ path: "/userCenter" });
    },
    goOut() {
      this.$store.dispatch("LogOut");
    },
  },
};
</script>

<style scoped lang="less">
.layout_header {
  background: #ffffff;
  .header_top {
    @media (min-width: 1200px) {
      width: 1200px;
      margin: 0 auto;
      height: 180px;
    }
    @media (min-width: 768px) and (max-width: 1200px) {
      width: 100%;
      height: 180px;
    }
    @media (max-width: 768px) {
      width: 100%;
      height: 160px;
    }

    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .logoBox {
      @media (min-width: 768px) and (max-width: 1200px) {
        margin-bottom: 60px;
      }
      @media (max-width: 768px) {
        margin-bottom: 45px;
      }
      .logo_top {
        display: flex;
        align-items: center;
        .logo1 {
          margin-right: 24px;
          @media (max-width: 768px) {
            margin-right: 15px;
          }
          img {
            @media (min-width: 768px) and (max-width: 1200px) {
              width: 120px;
              height: 70px;
            }
            @media (max-width: 768px) {
              width: 80px;
              height: 40px;
            }
          }
        }
        .logo3 {
          p {
            @media (min-width: 1200px) {
              font-size: 34px;
            }
            @media (min-width: 768px) and (max-width: 1200px) {
              font-size: 24px;
            }
            @media (max-width: 768px) {
              font-size: 16px;
            }

            color: #2077b5;
            font-weight: 700;
            margin: 0;
            padding: 0;
          }
          .logo_bottom {
            margin-top: 10px;
            text-align: center;
            @media (min-width: 1200px) {
              font-size: 12px;
            }
            @media (min-width: 768px) and (max-width: 1200px) {
              font-size: 12px;
            }
            @media (max-width: 768px) {
              font-size: 6px;
            }

            color: #0064ab;
          }
        }
      }
    }

    .backHome {
      position: absolute;
      right: 0;
      bottom: 15px;
      width: 110px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      border-radius: 25px;
      border: 1px solid #c8d7e3;
      font-size: 12px;
      cursor: pointer;
      background: #fff;
    }
    .loginStyle {
      position: absolute;
      right: 0;
      bottom: 15px;
    }

    .loginRegist {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      @media (min-width: 768px) and (max-width: 1200px) {
        position: absolute;
        right: 0;
        bottom: 15px;
      }
      @media (max-width: 768px) {
        position: absolute;
        right: 0;
        bottom: 15px;
        width: 100%;
        margin-right: 0;
        justify-content: flex-end;
      }
      .userInfo {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        @media (max-width: 768px) {
          width: 100%;
          justify-content: space-between;
          padding:0  15px;
          box-sizing: border-box;
        }
        .userImg {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 10px;
        }
        .userName {
          font-size: 14px;
          margin-right: 30px;
          @media (min-width: 768px) and (max-width: 1200px) {
            margin: 0 30px 0 0;
          }
          @media (max-width: 768px) {
            margin: 0 20px 0 0;
          }
          span {
            display: block;
            line-height: 24px;
            &:nth-child(2) {
              color: #0064ab;
              width: 125px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
      .language {
        margin-right: 35px;
        color: #000;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
  .header_bg {
    width: 100%;
    img {
      width: 100%;
      @media (max-width: 768px) {
        height: 150px;
      }
    }
  }
}
</style>